import { createFileRoute } from "@tanstack/react-router";
import BestTreatmentForDepressionGuidePage from "@/pages/articles/BestTreatmentForDepressionGuidePage";
export const Route = createFileRoute(
  "/whats-the-best-treatment-for-depression-a-simple-guide-to-understanding-your-options",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Best Treatment for Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "A simple guide to the best depression treatments: TMS, SAINT TMS, SPRAVATO, ketamine, and therapy. Compare your options in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Best Treatment for Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "A simple guide to the best depression treatments: TMS, SAINT TMS, SPRAVATO, ketamine, and therapy. Compare your options in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/whats-the-best-treatment-for-depression-a-simple-guide-to-understanding-your-options",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/whats-the-best-treatment-for-depression-a-simple-guide-to-understanding-your-options",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BestTreatmentForDepressionGuidePage />;
}
